import { useTranslation } from 'react-i18next';

import { useRepubContext } from '~/providers/repub-context';

import styles from './Filters.module.css';

export type MarketGroupAndName = [string, string];

export interface FiltersProps {
  dataTestId?: string;
  handleMarketChange: (marketGroupName: string) => void;
  marketGroupNames: string[];
  selectedMarketGroup: string;
}

export const Filters = ({ dataTestId, handleMarketChange, marketGroupNames, selectedMarketGroup }: FiltersProps) => {
  const { t } = useTranslation('label');
  const { repubIs } = useRepubContext();
  const stylesRef = repubIs.OC ? 'oc' : 'default';
  const filtersContainerClassNames = [styles.filtersContainer, styles[stylesRef]].join(' ');

  return (
    <div className={filtersContainerClassNames} data-testid={dataTestId || 'filters'}>
      {marketGroupNames.map(marketGroup => {
        const isActive = selectedMarketGroup === marketGroup;

        const filterClassNames = [styles.filter, styles[stylesRef], isActive ? styles.active : ''].join(' ');

        return (
          <button
            aria-pressed={isActive}
            className={filterClassNames}
            data-testid="filter-button"
            key={marketGroup}
            onClick={() => {
              handleMarketChange(marketGroup);
            }}
          >
            {t(marketGroup)}
          </button>
        );
      })}
    </div>
  );
};
